import type { AccessibleUsersResponse } from '@fleet-bffs/api-contract';
import { bffWebApi } from '~/api';
import type { SsoTokenResponse } from './types';

const usersApi = bffWebApi.injectEndpoints({
  endpoints: (build) => ({
    getSsoToken: build.mutation<SsoTokenResponse, void>({
      query: () => ({
        url: `${process.env.ENDPOINT_BFF}/users/sso-token`,
        method: 'POST',
      }),
    }),
    getAccessibleUsers: build.query<AccessibleUsersResponse, void>({
      query: () => ({
        url: `${process.env.ENDPOINT_BFF}/users/accessible`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetSsoTokenMutation, useGetAccessibleUsersQuery } = usersApi;
export default usersApi;
